// src/api/userAdminApi.ts

import client from "./client";
import { AdminUser, ApiResponse, PageResponse, PaymentStatus, UserCoupon, UserStatusFilter } from "../types";

export interface UserFilters {
  search?: string;
  status?: UserStatusFilter;
  plan?: PaymentStatus | "";
  page?: number;
  size?: number;
}

export const userAdminApi = {
  listar: ({ search, status, plan, page = 0, size = 20 }: UserFilters) =>
    client
      .get<ApiResponse<PageResponse<AdminUser>>>("/admin/users", {
        params: {
          search: search?.trim() || undefined,
          status: status || undefined,
          plan: plan || undefined,
          page,
          size,
        },
      })
      .then((r) => r.data),

  obtener: (userId: string) =>
    client.get<ApiResponse<AdminUser>>(`/admin/users/${userId}`).then((r) => r.data),

  activar: (userId: string) =>
    client.put<ApiResponse<AdminUser>>(`/admin/users/${userId}/activate`).then((r) => r.data),

  desactivar: (userId: string, reason: string) =>
    client
      .put<ApiResponse<AdminUser>>(`/admin/users/${userId}/deactivate`, { reason })
      .then((r) => r.data),

  /** Solo cupones del 100%: el usuario queda con Premium hasta que vence el cupón. */
  asignarCupon: (userId: string, couponId: string) =>
    client
      .post<ApiResponse<AdminUser>>(`/admin/users/${userId}/coupon`, { couponId })
      .then((r) => r.data),

  /** Cupones que el usuario usó o que se le asignaron */
  cupones: (userId: string) =>
    client.get<ApiResponse<UserCoupon[]>>(`/admin/users/${userId}/coupons`).then((r) => r.data),

  /**
   * Quita el cupón al usuario. Si es el que le da el Premium, la suscripción vuelve a como estaba antes.
   * @param userCouponId id de la asignación (no el id del cupón)
   */
  desasignarCupon: (userId: string, userCouponId: string) =>
    client
      .delete<ApiResponse<AdminUser>>(`/admin/users/${userId}/coupons/${userCouponId}`)
      .then((r) => r.data),
};
